import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import JobConfig from "@serie3/freelancesplaceapi/Config/Projects/JobConfig";
import JobView from "../projects/Jobs/JobView";

const PublicJobView = ({ jobId, showView, setShowView }) => {
  const [job, setJob] = useState(null);

  useEffect(() => {
    if (!jobId) return;
    setJob(null);
    const load = async () => {
      const res = await crudApi.show(JobConfig.endpoints.show, jobId);
      if (res) setJob(res);
    };
    load();
  }, [jobId]);

  return (
    <JobView job={job} showView={showView} setShowView={setShowView} />
  );
};

export default PublicJobView;
